import { css } from "@emotion/react";
import { useSelector } from "react-redux";

export default function AIBackgroundResultsHeader() {

    const strapiText = useSelector((state:any)=> state?.strapi?.entireStrapiData?.AIBackground?.AIBackground);

    return <div css={styles.container}>
        <div css={styles.topRow}>
            <div style={{display:"flex", color:'white', alignItems:'center'}}>
                <div css={styles.textContainer}>{strapiText?.HeaderTitle || "Custom Backgrounds"}</div>
            </div>
        </div>
        <div css={styles.divider}></div>
    </div>
}

const styles = {
    container: css`
        padding-top:16px;
        padding-bottom:10px;
        padding-left:10px;
        padding-right:10px;
        position:relative;
    `,
    textContainer: css`
        color: #FFF;

        font-family: Objectivity-Medium;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 170%; /* 23.8px */
        letter-spacing: 0.14px;
        display: flex;
        align-items: center;
    `,
    topRow: css`
        flex-direction:row;
        display:flex;
        justify-content:space-between;
        align-items:center;
    `,
    divider: css`
        position: absolute;
        width: 340px;
        height: 0.5px;
        left: 10px;
        bottom: 0px;
        background:rgba(255, 255, 255, 0.24);
    `,
}
